export default "__VITE_ASSET__36a38db8__"